"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var IFilterClause_1 = require("../api/types/IFilterClause");
var Filter = /** @class */ (function () {
    function Filter(compositeFilterClause) {
        if (compositeFilterClause === void 0) { compositeFilterClause = { operator: IFilterClause_1.FilterOps.and, clauses: [] }; }
        this.operator = compositeFilterClause.operator;
        this.clauses = compositeFilterClause.clauses;
    }
    Filter.prototype.and = function () {
        var leafFilterClause = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            leafFilterClause[_i] = arguments[_i];
        }
        return new Filter({
            operator: IFilterClause_1.FilterOps.and,
            clauses: this.clauses.concat(leafFilterClause)
        });
    };
    Filter.prototype.findFieldFilterClause = function (field, operator) {
        var clauses = this.findFieldFilterClauses(field, operator);
        return (clauses.length === 1) ? clauses[0] : undefined;
    };
    Filter.prototype.findFieldFilterClauses = function (field, operator) {
        return this.clauses
            .filter(Filter.isFieldFilterClause)
            .map(function (clause) { return clause; }) // Convert typing for TypeScript
            .filter(function (clause) { return (clause.field === field) && (!operator || clause.operator === operator); });
    };
    Filter.and = function () {
        var clauses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            clauses[_i] = arguments[_i];
        }
        return new Filter({ operator: IFilterClause_1.FilterOps.and, clauses: clauses });
    };
    Filter.search = function (search) {
        return {
            operator: IFilterClause_1.FilterOps.matches,
            value: search
        };
    };
    Filter.fieldEq = function (field, value) {
        return {
            operator: IFilterClause_1.FilterOps.eq,
            field: field,
            value: value
        };
    };
    Filter.stringFieldEq = function (field, value) {
        return Filter.fieldEq(field, value);
    };
    Filter.numberFieldEq = function (field, value) {
        return Filter.fieldEq(field, value);
    };
    Filter.stringFieldGte = function (field, value) {
        return {
            operator: IFilterClause_1.FilterOps.gte,
            field: field,
            value: value
        };
    };
    Filter.stringFieldLte = function (field, value) {
        return {
            operator: IFilterClause_1.FilterOps.lte,
            field: field,
            value: value
        };
    };
    Filter.stringFieldMatches = function (field, value) {
        return {
            operator: IFilterClause_1.FilterOps.matches,
            field: field,
            value: value
        };
    };
    Filter.stringArrayFieldHas = function (field, value) {
        return {
            operator: IFilterClause_1.FilterOps.has,
            field: field,
            value: value
        };
    };
    Filter.stringFieldInArray = function (field, values) {
        return {
            operator: IFilterClause_1.FilterOps.inArray,
            field: field,
            values: values
        };
    };
    Filter.findFieldFilterClause = function (field, operator, filter) {
        return (new Filter(filter)).findFieldFilterClause(field, operator);
    };
    Filter.isFieldFilterClause = function (clause) {
        return !!clause.field;
    };
    return Filter;
}());
exports.Filter = Filter;
//# sourceMappingURL=Filter.js.map